<template>
  <div v-loading="loading">
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
      </div>

      <el-tabs v-model="activeName">
        <el-tab-pane label="单据信息" name="first">
          <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
            <div class="edit-card">
              <div style="width: 88%; display: flex">
                <div class="start-label" />
                <span class="text">基础信息</span>
              </div>
              <el-row>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="no" label="入库单号" v-if="getIsView()">
                    <el-input disabled v-model="form.no"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 入库单号:{{ form.no }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                    <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                    </el-date-picker>
                  </el-form-item>
                  <span class="viewText" v-else> 创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="createdUserName" label="发起人" v-if="getIsView()">
                    <el-input disabled v-model="form.createdUserName"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 发起人:{{ form.createdUserName }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                    <el-input disabled v-model="form.ownerDeptName"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 所属科室:{{ form.ownerDeptName }}</span>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="distributionNo" label="验收单" v-if="getIsView()">
                    <el-select v-model="form.distributionNo" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getPurchaseDistributionList" @change="distributionChange" style="width: 100%">
                      <el-option v-for="item in STATIC_Distributions" :key="item.id" :label="item.no" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <span class="viewText" v-else> 验收单:{{ form.distributionNo }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="warehouseName" label="入库仓库" v-if="getIsView()">
                    <el-select v-model="form.warehouseName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getOneLevelWarehousesBySessionWarehouseId" @change="warehouseChange" style="width: 100%">
                      <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <span class="viewText" v-else> 入库仓库:{{ form.warehouseName }}</span>
                </el-col>
                <el-col :span="6" v-if="form.warehouseCategory == '1'" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="supplierName" label="供应商" v-if="getIsView()">
                    <el-select v-model="form.supplierName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getSuppliers" @change="supplierChange" style="width: 100%">
                      <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <span class="viewText" v-else> 供应商:{{ form.supplierName }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="date" label="入库日期" v-if="getIsView()">
                    <el-date-picker :disabled="!editMode" v-model="form.date" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="入库日期" style="width: 100%"></el-date-picker>
                  </el-form-item>
                  <span class="viewText" v-else> 入库日期:{{  parseTime(new Date(form.date), "{y}-{m}-{d}") }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="totalNumber" label="总数量" v-if="getIsView()">
                    <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 总数量:{{ form.totalNumber }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="totalAmount" label="总金额" v-if="getIsView()">
                    <el-input disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 总金额:{{ form.totalAmount }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="category" label="入库类型" v-if="getIsView()">
                    <el-radio-group disabled v-model="form.category">
                      <el-radio v-for="item in StockCategoryOptions" :key="item.id" :label="item.id">{{ item.name + "入库" }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <span class="viewText" v-else> 入库类型:{{  StockCategoryOptions.find(item => item.id === form.category)?.name }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="type" label="采购入库类型" v-if="getIsView()">
                    <el-radio-group :disabled="!editMode" v-model="form.type" @change="typeChange">
                      <el-radio :label="0">正常入库</el-radio>
                      <el-radio :label="1">捐赠入库</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <span class="viewText" v-else> 采购入库类型:{{ form.type == 0 ? '正常入库' : '捐赠入库' }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item label="结算金额" prop="balanceAmount" v-if="getIsView()">
                    <el-input disabled v-model="form.balanceAmount"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 结算金额:{{ form.balanceAmount }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item label="结算状态" prop="balanceStatus" v-if="getIsView()">
                    <el-input disabled v-model="form.balanceStatusName"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 结算状态:{{ form.balanceStatusName }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item label="开票金额" prop="billAmount" v-if="getIsView()">
                    <el-input disabled v-model="form.billAmount"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 开票金额:{{ form.billAmount }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item label="发票号码" prop="billNo" v-if="getIsView()">
                    <el-input disabled v-model="form.billNo"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 发票号码:{{ form.billNo }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="patientNo" label="住院号" v-if="getIsView()">
                    <el-input disabled v-model="form.patientNo"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 住院号:{{ form.patientNo }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="patientName" label="患者姓名" v-if="getIsView()">
                    <el-input disabled v-model="form.patientName"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 患者姓名:{{ form.patientName }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="doctorName" label="医生姓名" v-if="getIsView()">
                    <el-input disabled v-model="form.doctorName"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 医生姓名:{{ form.doctorName }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item prop="doctorNo" label="医生工号" v-if="getIsView()">
                    <el-input disabled v-model="form.doctorNo"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 医生工号:{{ form.doctorNo }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12" :class="!getIsView()?'viewCol':''">
                  <el-form-item label="备注" prop="remark" v-if="getIsView()">
                    <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 备注:{{ form.remark }}</span>
                </el-col>
                <el-col :span="6" v-if="form.category == 1" :class="!getIsView()?'viewCol':''">
                  <el-form-item label="备货使用科室" prop="stockUpUseDept" v-if="getIsView()">
                    <el-input disabled v-model="form.stockUpUseDeptName"></el-input>
                  </el-form-item>
                  <span class="viewText" v-else> 备货使用科室:{{ form.stockUpUseDeptName }}</span>
                </el-col>
                <el-col :span="6" :class="!getIsView()?'viewCol':''">
                  <el-form-item v-if="form.status == 2&&getIsView()" label="集采标识" prop="isChaoLiang" >
                    <!-- <el-input disabled v-model="form.isChaoLiang"></el-input> -->
                    <el-select v-model="form.isChaoLiang" disabled placeholder="请选择集采标识" style="width: 100%">
                      <el-option v-for="item in IsGouCaiOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <span class="viewText" v-if="form.status == 2&&!getIsView()"> 集采标识:{{ IsGouCaiOptions.find(item => item.id == form.isChaoLiang)?.name }}</span>
                </el-col>
                     <el-col :span="4" :class="!getIsView()?'viewCol':''">
                    <el-form-item v-if="system_setting.IsUsePDA &&getIsView()" prop="shelfState" label="上架状态" >
                    <el-select v-model="form.shelfState" disabled placeholder="请选择"  style="width: 100%">
                      <el-option v-for="item in ShelfStateOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <span class="viewText" v-if="system_setting.IsUsePDA && !getIsView()"> 上架状态:{{ ShelfStateOptions.find(item => item.id == form.shelfState)?.name }}</span>
                 </el-col>
              </el-row>
              <el-row style="margin-top: 20px"></el-row>
            </div>

            <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
              <div style="width: 88%; display: flex">
                <div class="start-label" />
                <span class="text">采购明细</span>
              </div>

              <div v-if="editMode" style="margin: 20px 0 12px 10px">
                <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
                <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
                <el-button class="btn default" size="small" v-preventReClick @click="openScanner">点击开始扫描</el-button>
                <el-input :disabled="!editMode" placeholder="扫描标签码添加明细" v-model="tagCode" ref="tagCodeInput" style="width:300px;margin-left:30px" @change="tagCodeChange"></el-input>
                <el-button  class="btn primary" type="primary" style="margin-left:20px"
                @click="showTransfer">自定义设置</el-button>
              </div>
              <div v-else style="margin: 20px 0 12px 10px">
                <el-button class="btn primary" type="primary" style="margin-right: 10px"
                @click="showTransfer">自定义设置</el-button>
              </div>
           
              <div v-if="tableHaeder.length>0">
                <CustomTable  ref="customTable" :tableData="form.details" @handleSelectionChange="handleChildSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
                :tableHeight="tableHeight"  :tableCode="route.name" :cellDblclick="cellDblclick"> 
                  <template slot="before">
                    <el-table-column type="index" width="50" fixed> </el-table-column>
                    <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
                  </template>
                  <template slot="after">
                    <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
                      <template slot-scope="scope">
                        <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
                      </template>
                    </el-table-column>
                  </template>
                </CustomTable>
              </div>
              <div v-else>
                <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
                  <el-table-column type="index" width="50" fixed> </el-table-column>
                  <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
                  <el-table-column show-overflow-tooltip prop="productName" label="产品" width="180" fixed></el-table-column>
                  <el-table-column show-overflow-tooltip prop="specName" label="产品规格" width="120" fixed></el-table-column>
                  <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
                  <!-- <el-table-column prop="brand" label="品牌" width="120"></el-table-column> -->
                  <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
                  <el-table-column prop="number" label="数量" width="120"></el-table-column>
                  <el-table-column prop="refundNumber" label="退货数量" width="80">
                    <template slot-scope="scope">
                      {{ scope.row.refundNumber?scope.row.refundNumber:'-' }}
                    </template>
                  </el-table-column>
                  <el-table-column v-if="system_setting.IsUsePDA" prop="shelvedNumber" label="上架数量" width="80">
                    <template slot-scope="scope">
                      {{ scope.row.shelvedNumber?scope.row.shelvedNumber:'-' }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="minUnit" label="最小单位" width="80">
                    <template slot-scope="scope">
                      {{ scope.row.minUnit?scope.row.minUnit:'-' }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="unit" label="包装单位" width="80">
                    <template slot-scope="scope">
                      {{ scope.row.unit?scope.row.unit:'-' }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" label="采购价" width="80"></el-table-column>
                  <el-table-column prop="amount" label="小计" width="90"></el-table-column>
                  <el-table-column prop="packSpec" label="包装规格" width="120"></el-table-column>
                  <el-table-column prop="locationName" label="货位" width="180">
                    <template slot-scope="scope">
                      <el-select :disabled="!editMode" placeholder="请选择货位" v-model="scope.row.locationName" filterable @change="locationChange(scope.row)">
                        <el-option v-for="item in STATIC_Locations" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="batch" label="批次号" width="120"></el-table-column>
                  <el-table-column prop="validityDate" label="有效期" width="120">
                    <template slot-scope="scope">
                      {{
                        scope.row.validityDate
                          ? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}")
                          : ""
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="longTime" label="长期" width="60">
                    <template slot-scope="scope">
                      {{ scope.row.longTime == 1 ? "是" : "否" }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="manufactureDate" label="生产日期" width="120">
                    <template slot-scope="scope">
                      {{
                        scope.row.manufactureDate
                          ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}")
                          : "-"
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="disinfectDate" label="灭菌日期" width="120">
                    <template slot-scope="scope">
                      {{
                        scope.row.disinfectDate
                          ? parseTime(new Date(scope.row.disinfectDate), "{y}-{m}-{d}")
                          : "-"
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="serialNo" label="序列号" width="120">
                    <template slot-scope="scope">
                      {{ scope.row.serialNo?scope.row.serialNo:'-' }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="disinfectBatch" label="灭菌批号" width="120">
                    <template slot-scope="scope">
                      {{ scope.row.disinfectBatch?scope.row.disinfectBatch:'-' }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="mainNo" label="主条码" width="180">
                    <template slot-scope="scope">
                      {{ scope.row.mainNo?scope.row.mainNo:'-' }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="traceNo" label="追溯码" width="180">
                    <template slot-scope="scope">
                      {{ scope.row.traceNo?scope.row.traceNo:'-' }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="distributionBatchName" label="集采批次" width="180">
                    <template slot-scope="scope">
                      {{ scope.row.distributionBatchName?scope.row.distributionBatchName:'-' }}
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip prop="productRegistCertName" label="产品注册证" width="180"></el-table-column>
                  <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号" width="180"></el-table-column>
                  <el-table-column show-overflow-tooltip prop="newProductId" label="产品ID" width="150" />
                  <el-table-column show-overflow-tooltip prop="productCode" label="商品代码" width="150" />
                  <el-table-column show-overflow-tooltip prop="medicalInsuranceCategoryNo" label="医保代码" width="150" />
                   <el-table-column v-if="system_setting.isShowSecondSupplier" prop="secondSupplierName" show-overflow-tooltip
                      width="140" label="二级供应商">
                      <template slot-scope="scope">
                        {{ scope.row.secondSupplierName?scope.row.secondSupplierName:'-' }}
                      </template>
                    </el-table-column>
                  <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200">
                    <template slot-scope="scope">
                      {{ scope.row.remark?scope.row.remark:'-' }}
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip prop="onlineNo" label="挂网号" width="120">
                    <template slot-scope="scope">
                      {{ scope.row.onlineNo?scope.row.onlineNo:'-' }}
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip prop="newOnlineNo" label="新挂网号" width="150">
                    <template slot-scope="scope">
                      {{ scope.row.newOnlineNo?scope.row.newOnlineNo:'-' }}
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
                    <template slot-scope="scope">
                      <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
           
            </div>

            <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
          </el-form>
          <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
            <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
              <el-row v-if="isScan">
                <el-col :span="24">
                  <el-form-item label="扫码框">
                    <el-input placeholder="请扫码" ref="no" @change="
                        (val) => {
                          mainNoChange(val, '1');
                        }
                      " v-model="childForm.no" @focus="scanInputFocus" @blur="scanInputBlur"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item prop="mainNo" label="主条码">
                    <el-input disabled placeholder="请输入主条码" v-model="childForm.mainNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="traceNo" label="追溯码">
                    <el-input disabled placeholder="请输入追溯码" v-model="childForm.traceNo"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item prop="supplierProductNo" label="供应商产品编码">
                    <el-input disabled v-model="childForm.supplierProductNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="productName" label="产品名称">
                    <el-input v-if="isScan" disabled v-model="childForm.productName"></el-input>
                    <SelectTable v-if="!isScan" :disabled="!editMode" :columns="supplierProductColumns" :placeholder="'请选择产品'" :innerName="childForm.productName" :dataList="STATIC_SupplierProducts" @filterMethod="getProductList" @change="productChange" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="specName" label="规格型号">
                    <el-input disabled v-model="childForm.specName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="productRegistCertId" label="产品注册证">
                    <el-input disabled v-model="childForm.productRegistCertName"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item prop="distributionBatchId" label="集采批次">
                    <el-input disabled v-model="childForm.distributionBatchName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="productRegistCertNo" label="注册证号">
                    <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="manufacturerName" label="生产厂家">
                    <el-input disabled v-model="childForm.manufacturerName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="onlineNo" label="挂网号">
                    <el-input disabled v-model="childForm.onlineNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="brand" label="品牌">
                    <el-input disabled v-model="childForm.brand"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item prop="minUnit" label="最小单位">
                    <el-input disabled v-model="childForm.minUnit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="unit" label="包装单位">
                    <el-input disabled v-model="childForm.unit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="packSpec" label="包装规格">
                    <el-input :disabled="!editMode" v-model="childForm.packSpec"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="disinfectDate" label="灭菌日期">
                    <el-date-picker :disabled="!editMode" v-model="childForm.disinfectDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item prop="disinfectBatch" label="灭菌批号">
                    <el-input :disabled="!editMode" placeholder="请输入灭菌批号" v-model="childForm.disinfectBatch"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="manufactureDate" label="生产日期">
                    <el-date-picker :disabled="!editMode" v-model="childForm.manufactureDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择生产日期" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="validityDate" label="有效期">
                    <el-date-picker :disabled="!editMode || Boolean(childForm.longTime)" v-model="childForm.validityDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择有效期" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item prop="longTime" label="长期">
                    <el-switch v-model="childForm.longTime" :disabled="!editMode" @change="longTimeChange(childForm)" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="batch" label="批次号">
                    <el-input :disabled="!editMode" placeholder="请输入批次号" v-model="childForm.batch"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item prop="serialNo" label="序列号">
                    <el-input :disabled="!editMode" placeholder="请输入序列号" v-model="childForm.serialNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="locationName" label="货位">
                    <el-select :disabled="!editMode" placeholder="请选择货位" v-model="childForm.locationName" filterable @change="childLocationChange" style="width: 100%">
                      <el-option v-for="item in STATIC_Locations" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="number" label="数量">
                    <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number" :controls="false" placeholder="请填写数量" @change="autoAmount" style="width: 100%"></el-input-number>
                    <!-- <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="autoAmount"></el-input> -->
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="price" label="单价">
                    <el-input disabled @input="autoAmount" v-model="childForm.price"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="amount" label="金额">
                    <el-input disabled v-model="childForm.amount"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="newProductId" label="产品ID">
                    <el-input disabled v-model="childForm.newProductId"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="productCode" label="商品代码">
                    <el-input disabled v-model="childForm.productCode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="newOnlineNo" label="新挂网号">
                    <el-input disabled v-model="childForm.newOnlineNo"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
                    <el-input disabled v-model="childForm.medicalInsuranceCategoryNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="remark" label="备注">
                    <el-input :disabled="!editMode" v-model="childForm.remark"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" style="">
              <el-button v-if="!isScan && editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
              <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
              <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
           
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="修改记录" name="second">
          <el-table ref="childTable1" border :data="form.productPriceUpdateLogs" style="width: auto; margin: 10px 0px" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column prop="supplierProductNo" label="供应商产品编码" min-width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productName" label="产品名称" min-width="150"></el-table-column>
            <el-table-column show-overflow-tooltip prop="specName" label="规格型号" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" min-width="150"></el-table-column>
            <el-table-column prop="batch" show-overflow-tooltip label="批次号" min-width="120"></el-table-column>
            <el-table-column prop="serialNo" show-overflow-tooltip label="序列号" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productCode" label="商品代码" min-width="100" />
            <el-table-column show-overflow-tooltip prop="newProductId" label="产品ID" min-width="100" />
            <el-table-column show-overflow-tooltip prop="createdUserName" label="修改人" min-width="100" />
            <el-table-column label="修改时间" min-width="180">
              <template slot-scope="scope">{{
                parseTime(new Date(scope.row.createdTime))
              }}</template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="content" label="修改内容" min-width="100" />

          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode && form.status!=0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button  v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>

    <el-dialog title="集采超量提示" :visible.sync="chaoLiangDialogDisable" :center="true" width="800px" :before-close="cancelChaoLiangDialog" :close-on-click-modal="false">
      <div class="warn-text">本次入库存在集采超量产品，超量明细如下：</div>
      <el-table ref="multipleTable" border :data="chaoLiangData" :max-height="tableHeight" style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <el-table-column show-overflow-tooltip prop="supplierProductNo" min-width="150" label="供应商产品编码"></el-table-column>
        <el-table-column show-overflow-tooltip prop="productName" min-width="150" label="产品名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="specName" min-width="150" label="规格型号"></el-table-column>
        <el-table-column prop="number" min-width="95" label="超量数量"></el-table-column>
      </el-table>
      <div class="warn-text">
        若【继续】，则超量部分将自动拆分生成超量入库单，是否继续？
      </div>

      <div slot="footer" class="dialog-footer" style="">
        <el-button class="btn" size="small" v-preventReClick @click="cancelChaoLiangDialog">取 消</el-button>
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChaoLiangForm">继 续</el-button>
      </div>
    </el-dialog>
    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData" 
    @tagCodeDelete="tagCodeDelete"
    @close="closeLabelDetailsDialog"/>
    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
    @viewDetails="viewDetails"
     @tagCodeDelete="tagCodeDelete"
     @close="closePackageLabelDialog"/>
     <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import InStockScan from "@/mixin/inStockScan-mixin";
import tagCodeMixin from "@/mixin/tagCode-mixin";
import {
  GetPurchaseDistributionById,
  GetAcceptInStockById,
  SaveAcceptInStock,
  RejectAcceptInStock,
  PushPurchaseInStock,
  ValidatePMInStockDetail,
  GetWarehouseById,
  AcceptChaoLiangValidate,
  GetTagCodeDetailsByTableNoAndDetailId,
  SaveAcceptInStockTemp
} from "@/api";
import {
  StockCategoryOptions,
  IsGouCaiOptions,
  ShelfStateOptions
} from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
import { Debounce } from "@/utils/utils";
export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, InStockScan,tagCodeMixin],
  components: {
    SelectTable,
    ApproveInfo,
    LabelDetailsDialog,
    PackageLabelDialog
  },
  data () {
    return {
      GetDataAction: GetAcceptInStockById,
      SaveDataAction: SaveAcceptInStock,
      reject: RejectAcceptInStock,
      form: {},
      StockCategoryOptions: StockCategoryOptions,
      IsGouCaiOptions: IsGouCaiOptions,
      ShelfStateOptions: ShelfStateOptions,
      SaveTempAction: SaveAcceptInStockTemp,
      rules: {
        warehouseName: [{
          required: true,
          message: "请选择入库仓库",
          trigger: "blur",
        },],
        date: [{
          required: true,
          message: "请选择入库日期",
          trigger: "blur",
        },],
        category: [{
          required: true,
          message: "请选择入库类型",
          trigger: "blur",
        },],
        type: [{
          required: true,
          message: "请选择采购入库类型",
          trigger: "blur",
        },],
        supplierName: [{
          required: true,
          message: "请选择供应商",
          trigger: "blur",
        },],
      },
      childFormRules: {
        productName: [{
          required: true,
          message: "请选择产品",
          trigger: "blur",
        },],
        manufactureDate: [
          // { required: true, message: "请选择生产日期", trigger: "blur" },
          {
            validator: this.validateManufacturerDate,
            trigger: "blur",
          },
          {
            validator: this.validateDateRange,
            trigger: "blur",
          },
        ],
        validityDate: [
          // { required: true, message: "请选择有效期", trigger: "blur" },
          {
            validator: this.validateValidityDate,
            trigger: "blur",
          },
          {
            validator: this.validateDateRange,
            trigger: "blur",
          },
        ],
        // batch: [{ required: true, message: "请输入批次号", trigger: "blur" }],
        // productRegistCertId: [{
        //   required: true,
        //   message: "请选择产品注册证",
        //   trigger: "blur"
        // }],
        packSpec: [{
          required: true,
          message: "请输入包装规格",
          trigger: "blur",
        },],
        price: [{
          required: true,
          message: "请输入采购价",
          trigger: "blur",
        },],
        number: [{
          required: true,
          message: "数量不能为空",
          trigger: "blur",
        },
        {
          type: "number",
          min: 0.01,
          message: "数量必须大于0",
          trigger: "blur",
        },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},
      isScan: false,
      activeName: "first",
      chaoLiangDialogDisable: false,
      chaoLiangData: [],
      rfid:'',
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    if (query.distributionId) {
      this.distributionChange(query.distributionId);
    }
    this.getOneLevelWarehousesBySessionWarehouseId("");
    this.getSuppliers("");
    this.getPurchaseDistributionList("");
    // this.getDepts("");
    this.getTabelList("");
  },

  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      return new Promise((resolve, reject) => {
        this.GetDataAction({
          id,
        }).then((res) => {
          
          // this.resetForm()
          this.form = res.returnData;
          this.getLocations(this.form.warehouseId);
          this.form.details.forEach((e, index) => {
            e.$index = index + 1;
          });

          this.initWorkFlowProperty(this.form);
          resolve(this.form);
        });
      });
    },
    deptChange (val) {
      let arr = this.STATIC_Depts.filter((res) => res.id == val);
      this.form.stockUpUseDeptName = arr[0].name;
      this.form.stockUpUseDept = arr[0].id;
    },
    // 保存
    submit (showUpdatePrice) {
      this.$store.dispatch('SetLoading',true)
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$store.dispatch('SetLoading',false)
          return false;
        }
        AcceptChaoLiangValidate(this.form).then((res) => {
          if (res.returnData && res.returnData.length > 0) {
            this.chaoLiangData = res.returnData;
            this.chaoLiangDialogDisable = true;
            this.$store.dispatch('SetLoading',false)
          } else {
            this.save();
          }
        });
      });
    },
    submitChaoLiangForm:Debounce(function(){
         this.save();
    }),
    save () {
      
      this.SaveDataAction(this.form).then((res) => {
        this.loading = false 
        // 是否需要上传数据到价格监管平台
        var isNeedPushToPriceMonitor = res.returnData.isNeedPushToPriceMonitor;

        if (
          isNeedPushToPriceMonitor &&
          res.returnData.status == 2 &&
          this.system_setting.isAutoSubmitOrderToPriceMonitor
        ) {
          let id = res.returnData.id;
          // 上传订单到价格监管平台，流程审批通过的数据直接上传
          ValidatePMInStockDetail({
            id: id
          }).then((res) => {
            if (res.returnData && res.returnData.length > 0) {
              var exceptionList = res.returnData.exceptionList;
              var notFinishCompareList = res.returnData.notFinishCompareList;
              // 提示
              if (exceptionList.length > 0 || notFinishCompareList.length > 0) {
                const h = this.$createElement;
                let content = [
                  h("p", "上传订单到价格监管平台时，检测到此采购入库存在以下异常："),
                ];
                if (exceptionList.length > 0) {
                  // content = [h('p', '以下所选医院采购订单存在价格异常：')]
                  exceptionList.forEach((item) => {
                    content.push(
                      h(
                        "p", {
                        style: "color:red",
                      },
                        `价格异常`
                      )
                    );
                  });
                }
                if (notFinishCompareList.length > 0) {
                  // content = [h('p', '以下所选医院采购订单存在未对照的目录：')]
                  notFinishCompareList.forEach((item) => {
                    content.push(
                      h(
                        "p", {
                        style: "color:red",
                      },
                        `存在未对照的目录`
                      )
                    );
                  });
                }

                content.push(h("p", "确定要继续上传吗？"));

                this.$confirm("提示", {
                  title: "提示",
                  type: "warning",
                  message: h("div", content),
                })
                  .then(() => {
                    // 上传订单
                    this.pushOrder(id);
                  })
                  .catch(() => {
                    this.$my_message(`执行成功`, "success");
                    sessionStorage.setItem("editMode", 0);
                    // this.$router.push({ path: this.getMainPath(this.$route.path) });
                    this.routePushWithParams(
                      this.getMainPath(this.$route.path),
                      this.$route.params
                    );
                  });
              } else {
                this.pushOrder(id);
              }
            } else {
              // 上传订单
              this.pushOrder(id);
            }
          });
        } else {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(
            this.getMainPath(this.$route.path),
            this.$route.params
          );
        }
      }).catch(()=>{
          this.loading = false
      });
    },
    pushOrder (id) {
      PushPurchaseInStock({
        id: id,
      })
        .then((res) => {
          this.$my_message("上传成功", "success");
          // sessionStorage.setItem("editMode", 0);
          // // this.$router.push({ path: this.getMainPath(this.$route.path) });
          // this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        })
        .finally(() => {
          sessionStorage.setItem("editMode", 0);
          this.routePushWithParams(
            this.getMainPath(this.$route.path),
            this.$route.params
          );
        });
    },
    resetForm () {
      this.form = {
        supplierId: "",
        supplierName: "",
        deliveryTime: new Date(),
        totalNumber: 0,
        totalAmount: 0,
        orderNo: "",
        category: 0,
        warehouseName: "",
        type: 0,
        remark: "",
        isChaoLiang: 0,
        balanceStatus: 2,
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        // warehouseCategory: "1",
        warehouseId: "", // this.userInfo.defaultWarehouseId,
        warehouseName: "", // this.userInfo.defaultWarehouseName,
        warehouseManagerId: "", // this.userInfo.defaultWarehouseManagerId,
        warehouseManagerName: "", // this.userInfo.defaultWarehouseManagerName,
        orgCode :sessionStorage.getItem('orgId'),
      };
      if(this.system_setting.IsUsePDA){
        this.form.shelfState = 0        
      }
      this.setDefaultWarehouseBySessionWarehouseId(1);
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.isScan = false;
    },

    handleDeleteChildForm () {
      if(this.checkIsRfid(this.childMultipleSelection)){
        this.$my_message(`存在打包类标签明细，不能删除！`, "warning");
        return
      }
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.isScan = false;
      this.getProductRegistCertDetails(this.childForm.productId);
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        no: "",
        productName: "",
        specName: "",
        manufacturerName: "",
        locationName: "",
        mainNo: "",
        traceNo: "",
        supplierProductId: "",
        productId: "",
        specId: "",
        productRegistCertId: "",
        productRegistCertNo: "",
        onlineNo: "",
        unit: "",
        minUnit: "",
        packSpec: "",
        manufacturerId: "",
        locationId: "",
        manufactureDate: "",
        batch: "",
        validityDate: "",
        serialNo: "",
        number: 1,
        refundNumber: 0,
        price: 0,
        amount: 0,
        remark: "",
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();

      this.getProductList("");
    },
    pushChildForm (close) {
      let result = true;
      this.$refs["childForm"].validate((valid) => {
        result = valid;
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        let fn = () => {
          
          if (this.childForm.mainNo && this.childForm.traceNo) {
            var childForm = this.childForm;
            // 添加行
            let arr = this.form.details.filter(
              (item) =>
                item.mainNo == childForm.mainNo && item.traceNo == childForm.traceNo
            );
            
            // 添加行记录
            if (arr.length > 0) {
              // 存在则把列表的数据拿过来，并且数量加1
              this.form.details = this.form.details.map((item) => {
                if (
                  item.mainNo == childForm.mainNo &&
                  item.traceNo == childForm.traceNo
                ) {
                  item.packSpec = childForm.packSpec;
                  item.locationId = childForm.locationId;
                  item.locationName = childForm.locationName;
                  item.manufactureDate = childForm.manufactureDate;
                  item.batch = childForm.batch;
                  item.validityDate = childForm.validityDate;
                  item.serialNo = childForm.serialNo;
                  item.remark = childForm.remark;
                  item.number = childForm.number;
                  // item.unUseNumber = childForm.unUseNumber
                  item.price = childForm.price;
                  item.amount = childForm.amount;
                  item.longTime = childForm.longTime;
                }
                return item;
              });
            } else {
              // 不存在则添加行记录
              var childForm = JSON.parse(JSON.stringify(this.childForm));
              childForm.$index = this.form.details.length + 1;
              this.form.details.push(childForm);
            }
          } else {
            if (this.editChildren) {
              let item = this.form.details.find((e) => e.$index == this.childForm.$index);
              Object.assign(item, this.childForm);
            } else {
              this.form.details.push(this.childForm);
            }
          }

          this.autoTotalAmount();
          this.resetDetailFormData();
          if (close) {
            this.openSubformModal = false;
            this.count = 0;
            this.isScan = false;
          }
        };

        let emptyArr = [];
        if (!this.childForm.batch) {
          emptyArr.push("[批次号]");
        }
        if (!this.childForm.manufactureDate) {
          emptyArr.push("[生产日期]");
        }
        if (!this.childForm.validityDate && this.childForm.longTime != 1) {
          emptyArr.push("[有效期]");
        }
        if (emptyArr && emptyArr.length > 0) {
          this.$confirm("提示", {
            title: "提示",
            type: "warning",
            message: `${emptyArr.join("、")}未填写，是否继续?`,
          })
            .then(() => {
              fn();
            })
            .catch((e) => {
              result = false;
              return false;
            });
        } else {
          fn();
        }
      });
      return result;
    },
    // childNumberChange () {
    //   // this.childForm.notReceivedNumber = this.childForm.number
    //   // this.childForm.planOrderNumber = this.childForm.number
    //   // this.childForm.actualOrderNumber = this.childForm.number
    //   this.autoAmount();
    // },
    autoAmount () {
      // this.childForm. = this.childForm.price
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      // this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },

    // scan

    openScanner (ev) {
      this.count = 0;
      this.resetDetailFormData();
      this.isScan = true;
      this.openSubformModal = true;

      ev.target.blur();
    },
 
    // change event
    distributionChange (val) {
      this.supplierId = "";
      this.supplierName = "";
      this.form.details = [];

      this.form.distributionId = val;
      // var distributions = this.STATIC_Distributions.filter(item => item.id == val)
      // this.form.distributionId = val
      // if (distributions && distributions.length > 0) {

      GetPurchaseDistributionById({
        id: val,
      }).then((res) => {
        if (!res.successful) {
          this.$my_message(`获取信息失败：${res.errorMessage}`, "warning");
          this.$store.dispatch('SetLoading',false)
          return;
        }
        this.form.distributionNo = res.returnData.no;
        this.form.supplierId = res.returnData.supplierId;
        this.form.supplierName = res.returnData.supplierName;
        this.form.remark = res.returnData.remark;
        this.form.warehouseId = res.returnData.oneLevelWarehouseId;
        this.form.warehouseName = res.returnData.oneLevelWarehouseId;

        this.warehouseChange(this.form.warehouseId);
        if (res.returnData.billNo) {
          this.form.billNos = res.returnData.billNo;
          this.form.balanceStatus = 0;
          this.form.billAmount = res.returnData.totalAmount;
          this.form.balanceAmount = res.returnData.totalAmount;
        }

        var details = res.returnData.details;
        this.form.details = details;
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
          if (this.form.type == 1) {
            e.price = 0;
            e.billingPrice = 0;
            e.amount = 0;
          }
        });
        this.form.purchaseOrderId = res.returnData.purchaseOrderId;
        this.form.totalNumber = res.returnData.totalNumber;
        this.form.totalAmount = res.returnData.totalAmount;
        if (this.form.type == 1) {
          this.form.totalAmount = 0;
        }
      });
      // }

      this.getProductList("", 1);
    },
    locationChange (row) {
      row.locationId = row.locationName;
    },
    childLocationChange (val) {
      this.childForm.locationId = val;
    },
    supplierChange (val) {
      this.form.supplierId = val;
      this.getProductList("");
      this.form.details = [];
    },
    warehouseChange (val) {
      this.form.warehouseId = val;
      let arr = this.STATIC_OneLevelWarehouses.filter((item) => item.id == val);
      this.form.warehouseName = arr[0].name;
      this.form.warehouseCategoryName = arr[0].category == 1 ? "一级库房" : "二级库房";
      this.form.warehouseCategory = arr[0].category;
      this.getLocations(val);
    },
    productChange (row) {

      let id = this.childForm.id;
      if(row.onelevelWarehouseId!=this.form.warehouseId){
        row.locationId = null
      }else{
        row.locationName = this.STATIC_Locations.filter(r=>r.id==row.locationId)[0]?.name
      }
      this.childForm = Object.assign(this.childForm, row); // this.mapper.SupplierProduct2Form(this.childForm, arr[0])
      this.childForm.id = id;
      this.childForm.supplierProductId = row.id;
      this.childForm.number = 1;
      this.childForm.price = this.childForm.purchasePrice;
      this.childForm.amount = this.childForm.price;
      this.childForm.supplierProductNo = this.childForm.no;
      this.childForm.remark = "";

      if (this.form.type == 1) {
        this.childForm.price = 0;
        this.childForm.billingPrice = 0;
        this.childForm.amount = 0;
      }

      this.$refs.number.focus();
      this.$refs.number.select();

      this.$refs.childForm.validateField("productName");
    },
    typeChange (val) {
      if (val == 1) {
        // 捐赠入库
        if (this.form.details) {
          this.form.details.map((item) => {
            item.price = 0;
            item.billingPrice = 0;
            item.amount = 0;
            return item;
          });
        }
      } else {
        // 正常入库
        this.form.details = [];
      }

      this.autoTotalAmount();
    },

    getProductList (keyWord, num) {
      var supplierId = 0;
      if (this.form.supplierId) {
        supplierId = this.form.supplierId;
      }
      var orderId = "";
      if (this.form.distributionId) {
        orderId = this.form.distributionId;
      }
      let IsEnabledTempPurchaseGroup = num == 1 ? num : "";
      // query.pageIndex = 1
      // query.pageSize = 100
      // query.supplierId = supplierId
      // query.distributionId = orderId
      // query.status = 2

      this.getSupplierProducts(
        //query)
        {
          keyWord: keyWord,
          pageIndex: 1,
          pageSize: 100,
          supplierId: supplierId,
          distributionId: orderId,
          status: 2,
          isEnabled: 1,
          IsEnabledTempPurchaseGroup: IsEnabledTempPurchaseGroup,
          isReturnLocationId:1

        }
      );
    },
    // getWarehouseList (keyWord) {
    //   GetDeptWarehouses({ keyWord: keyWord, state: 1 })
    //     .then(res => {
    //       this.warehouseList = res.returnData;
    //     })
    // },
    getOrderList (keyWord) {
      var supplierId = 0;
      if (this.form.supplierId) {
        supplierId = this.form.supplierId;
      }

      GetPurchaseOrders({
        no: keyWord,
        pageIndex: 1,
        pageSize: 100,
        supplierId: supplierId,
        orderStatus: [0, 1],
        status: 2,
      }).then((res) => {
        this.orderList = res.returnData.data;
      });
    },

    getPurchaseDistributionList (keyWord) {
      var query = {
        keyWord: keyWord,
        orderStatus: "0,1,4",
        status: 2,
      };
      this.getPurchaseDistributions(query)
    },
    cancelChaoLiangDialog () {
      this.chaoLiangDialogDisable = false;
    },

  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}

.warn-text {
  margin: 10px 0;
  font-size: 15px;
  font-weight: 600;
}
</style>
